exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\ntr[data-v-fd03e2f4]:hover {\n    background-color: transparent !important;\n}\n\n", ""]);
